import { CrudConsumer, CrudConsumerObject } from "consumerjs";
import { API_KEY, getApiBaseEndpoint } from "./api";

/**
 * PtvAnswer.
 */
class PtvAnswer extends CrudConsumerObject {}

/**
 * PtvAnswer consumer.
 */
export class PtvAnswerConsumer extends CrudConsumer {
    constructor(
        endpoint = `${getApiBaseEndpoint()}/ptv-answers/`,
        objectClass = PtvAnswer,
        options = { csrfProtection: false }
    ) {
        super(endpoint, objectClass, options);

        this.addHeader("AUTHORIZATION", API_KEY);
    }

    /**
     * Sets the language.
     * @param {Object} language
     */
    setLanguage(language) {
        this.endpoint = `${getApiBaseEndpoint(language)}/ptv-answers/`;
    }

    /**
     * Sets the session header.
     * @param {Session} session
     */
    setSession(session) {
        this.addHeader("x-sessionid", session.session);
    }
}
